import { getAllData } from '@/api/battrerySwap/index';

const GET_STATISTIC_DATA = 'getStatisticData'; // 换电数据统计
const GET_CHART_EXCHANG_TEN_DAYS = 'getChartExchangTenDays'; // 近10天换电量
const GET_CHART_USER_TEN_DAYS = 'getChartUserTenDays'; // 近10天用户量
const GET_CHART_BATTERY_TEN_DAYS = 'getChartBatteryTenDays'; // 近10天电池使用数量
const GET_CHART_COMBO_TEN_DAYS = 'getChartComboTenDays';// 近10天套餐收益
const GET_STATISTIC_TODAY = 'getStatisticToday';// 今日统计数据
const GET_STATISTIC_BATTERY_LINE = 'getStatisticBatteryLine';// 在线电池数据
const GET_STATISTIC_CABINET_LINE = 'getStatisticCabinetLine'; // 在线换电柜数据
const GET_STATISTIC_ASSET_DATA = 'getStatisticAssetData'; // 资源数据
const GET_DATE_LIST = 'getDateList';// 获取日期
const GET_IMG_LIST = 'getImgList'; // 获取图片列表
const GET_STATISTIC_SITE_DATA = 'getStatisticSiteData'; // 获取站点数据

const batterySwap = {
  namespaced: true,
  state: () => ({
    statisticData: {}, // 换电数据统计
    exchangTenDaysList: [], // 近10天换电量
    chartUserTenDaysList: [], // 近今10天用户量
    chartBatteryTenDaysList: [], // 近10天电池使用数量
    chartComboTenDaysList: [], // 近10天套餐收益
    statisticTodayData: {}, // 今日数据统计
    statisticBatteryLineData: {}, // 在线电池数据
    statisticCabinetLineData: {}, // 在线换电柜数据
    statisticAssetData: {}, // 资源数据
    statisticSiteData: [], // 站点数据
    dateList: [], // Y轴日期，
    imgList: [], // 轮播图片
  }),
  mutations: {
    [GET_STATISTIC_DATA]: (state, commit) => {
      state.statisticData = [...commit];
    },
    [GET_CHART_EXCHANG_TEN_DAYS]: (state, commit) => {
      state.exchangTenDaysList = commit;
    },
    [GET_CHART_USER_TEN_DAYS]: (state, commit) => {
      state.chartUserTenDaysList = commit;
    },
    [GET_CHART_BATTERY_TEN_DAYS]: (state, commit) => {
      state.chartBatteryTenDaysList = commit;
    },
    [GET_CHART_COMBO_TEN_DAYS]: (state, commit) => {
      state.chartComboTenDaysList = commit;
    },
    [GET_STATISTIC_TODAY]: (state, commit) => {
      state.statisticTodayData = commit;
    },
    [GET_STATISTIC_BATTERY_LINE]: (state, commit) => {
      state.statisticBatteryLineData = commit;
    },
    [GET_STATISTIC_CABINET_LINE]: (state, commit) => {
      state.statisticCabinetLineData = commit;
    },
    [GET_STATISTIC_ASSET_DATA]: (state, commit) => {
      state.statisticAssetData = commit;
    },
    [GET_DATE_LIST]: (state, commit) => {
      state.dateList = commit;
    },
    [GET_IMG_LIST]: (state, commit) => {
      state.imgList = commit;
    },
    [GET_STATISTIC_SITE_DATA]: (state, commit) => {
      state.statisticSiteData = commit;
    },
  },
  actions: {
    // 获取近十天换电量
    async getAllData (context) {
      const res = await getAllData();
      const { code, data } = res;
      if (code === '200' && data) {
        const {
          chartExchangTenDays,
          chartUserTenDays,
          chartBatteryTenDays,
          chartComboTenDays,
          statisticData,
          statisticToday,
          statisticSiteData,
          pictureLoop,
        } = data;

        // 处理 statisticSiteData 数据
        const statisticSiteDataList = [];
        if (statisticSiteData.length > 0) {
          statisticSiteData.forEach((item) => {
            const { lng, lat, siteName } = item;
            const stationName = siteName;
            const coordinates = [lng, lat];
            statisticSiteDataList.push({
              stationId: Math.random(),
              coordinates,
              stubGroupName: siteName,
              ...item,
            });
          });
        }

        context.commit(GET_CHART_EXCHANG_TEN_DAYS, Object.values(chartExchangTenDays));
        context.commit(GET_CHART_USER_TEN_DAYS, Object.values(chartUserTenDays));
        context.commit(GET_CHART_BATTERY_TEN_DAYS, Object.values(chartBatteryTenDays));
        context.commit(GET_CHART_COMBO_TEN_DAYS, Object.values(chartComboTenDays));
        context.commit(GET_STATISTIC_ASSET_DATA, statisticData);
        context.commit(GET_STATISTIC_TODAY, statisticToday);
        context.commit(GET_DATE_LIST, Object.keys(chartExchangTenDays));
        context.commit(GET_IMG_LIST, pictureLoop);
        context.commit(GET_STATISTIC_SITE_DATA, statisticSiteDataList);
      }
    },

  },
  getters: {
    exchangTenDaysList: (state) => state.exchangTenDaysList,
    chartUserTenDaysList: (state) => state.chartUserTenDaysList,
    chartBatteryTenDaysList: (state) => state.chartBatteryTenDaysList,
    chartComboTenDaysList: (state) => state.chartComboTenDaysList,
    statisticAssetData: (state) => state.statisticAssetData,
    statisticTodayData: (state) => state.statisticTodayData,
    dateList: (state) => state.dateList,
    imgList: (state) => state.imgList,
    statisticSiteData: (state) => state.statisticSiteData,
  },
};

export default batterySwap;
